/**
 * Returns today's date as YYYY-MM-DD string.
 */
export const today = () => new Date().toISOString().slice(0, 10);

/**
 * Returns the date N months ago as YYYY-MM-DD string.
 */
export const monthsAgo = (n = 1) => {
  const d = new Date();
  d.setMonth(d.getMonth() - n);
  return d.toISOString().slice(0, 10);
};

/**
 * Validates a date range.
 * Returns null if valid, or an error string if invalid.
 *
 * @param {string} from - YYYY-MM-DD
 * @param {string} to   - YYYY-MM-DD
 */
export const validateDateRange = (from, to) => {
  if (!from && !to) return null;
  if (from && to && from > to) return "Start date cannot be after end date";
  if (to && to > today()) return "End date cannot be in the future";
  return null;
};
